import { CreateDiscountRequestBody } from '@boltenergy-be/shared'
import { ApplyDiscountParams, ApplyDiscountResponse } from './types.ts'
import { UserTypes } from 'store/auth/types.ts'
import { Flow } from 'types/logging.ts'
import { log } from 'utils/logging.ts'
import { getUserType } from 'utils/userType.ts'
import { Methods } from 'types/request.ts'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'

export const applyDiscount = async ({ contractNumber, inputs }: ApplyDiscountParams): Promise<ApplyDiscountResponse> => {
  const userType = getUserType()
  if (!userType || userType !== UserTypes.SUPER_USER) {
    log({ error: `Cannot apply discount as ${userType}`, identifier: `[${Flow.DISCOUNTS}:applyDiscount]` })
    return { success: false }
  }

  try {
    const notSuccessfulDiscounts: string[] = []
    await Promise.all(
      inputs.linkedDiscounts.map(async (discount, index) => {
        const body: CreateDiscountRequestBody = {
          direction: inputs.direction,
          fromDate: inputs.startDate,
          reason: inputs.reason,
          salesforcePromoCode: inputs.code,
          haugazelDiscountCode: discount
        }

        const res = await newRequest(
          getAxiosRequestConfigBoltBackend(Methods.POST, `/resources/service-contracts/${contractNumber}/discounts`, body)
        )

        if (!res.success) {
          notSuccessfulDiscounts.push(discount)

          log({
            error: `Something went wrong with the discount application for ${contractNumber}.`,
            identifier: `[${Flow.DISCOUNTS}:applyDiscount]`,
            metaData: {
              [`discountError-${index}`]: {
                discount,
                res
              }
            }
          })
        }
      })
    )

    if (!notSuccessfulDiscounts.length) {
      return { success: true }
    } else {
      return {
        success: false,
        notSuccessfulDiscounts
      }
    }
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'Unknown error in apply discount',
      identifier: `[${Flow.DISCOUNTS}:CATCH:applyDiscount]`
    })
    return { success: false }
  }
}
